import { StateCreator } from 'zustand';

import { ActionsStoreSliceProps } from './actionsSlice.types.ts';

import { ActionSortCriteriaEnum } from '@/modules/Actions/types/actions.types.ts';

export const createActionsSlice: StateCreator<ActionsStoreSliceProps> = (set, get) => ({
  actionFilters: {
    archive: {
      date: new Date(),
      searchKey: '',
      subCategories: [],
    },
    equipment: [],
    safety: [],
    searchKey: '',
    sort: ActionSortCriteriaEnum.MOST_IMPORTANT,
    system: [],
    zone: [],
  },
  actions: [],
  alerts: [],
  alertsLoading: true,
  archivedActions: [],
  archivedAlerts: [],
  archivedAlertsLoading: true,
  metrics: [],
  metricsLoading: false,
  selectedAction: null,
  setActionFilters: dataOrSetter => {
    const existingFilters = get().actionFilters;
    const newFilters =
      typeof dataOrSetter === 'function' ? dataOrSetter(existingFilters) : dataOrSetter;
    set({ actionFilters: { ...existingFilters, ...newFilters } });
  },
  setActions: dataOrSetter => {
    const actions = get().actions;
    const modifiedActions = Array.isArray(dataOrSetter) ? dataOrSetter : dataOrSetter(actions);
    set({ actions: modifiedActions, alertsLoading: false });
  },
  setAlerts: dataOrSetter => {
    const modifiedAlerts = Array.isArray(dataOrSetter) ? dataOrSetter : dataOrSetter(get().alerts);
    set({ alerts: modifiedAlerts, alertsLoading: false });
  },
  setArchivedActions: dataOrSetter => {
    const actions = get().archivedActions;
    const modifiedActions = Array.isArray(dataOrSetter) ? dataOrSetter : dataOrSetter(actions);
    set({ alertsLoading: false, archivedActions: modifiedActions });
  },
  setArchivedAlerts: dataOrSetter => {
    const modifiedAlerts = Array.isArray(dataOrSetter)
      ? dataOrSetter
      : dataOrSetter(get().archivedAlerts);
    set({ archivedAlerts: modifiedAlerts, archivedAlertsLoading: false });
  },
  setArchivedAlertsLoading: isLoading => {
    set({ archivedAlertsLoading: isLoading });
  },
  setMetrics: (newMetricsData, isLoading) => {
    set({
      metrics: newMetricsData,
      metricsLoading: isLoading || false,
    });
  },
  setSelectedAction: action => {
    set(() => ({
      selectedAction: action,
    }));
  },
  setWsAlertAvailable: available => {
    set({ wsAlertAvailable: available });
  },
  wsAlertAvailable: false,
});
